module.exports = __webpack_public_path__ + "media/images/sport--snowboard-8e5d22de9db384daab6687826fcd6680.png";